import React from 'react';
import { ReactComponent as FacebookIcon } from 'Assets/svg/company-icon/facebook-logo.svg';
import { ReactComponent as TwitterIcon } from 'Assets/svg/company-icon/twitter-new-logo.svg';
import { ReactComponent as YoutubeIcon } from 'Assets/svg/company-icon/youtube-logo.svg';
import { ReactComponent as LinkedinIcon } from 'Assets/svg/company-icon/linkedin-logo.svg';

const SocialLinks = props => {
  const {
    facebookId = '',
    twitterId = '',
    youtubeId = '',
    linkedInId = '',
    newLinkedInId = '',
    currentTab = '',
    hoverEffect = false,
    allUpdatedFlag = false,
  } = props;

  const checkAndAddHttpProtocal = value => {
    if (value.includes('http://') || value.includes('https://')) return value;
    return `https://${value}`;
  };

  return (
    <>
      {((facebookId !== '' && facebookId !== null) ||
        (twitterId !== '' && twitterId !== null) ||
        (youtubeId !== '' && youtubeId !== null) ||
        (linkedInId !== '' && linkedInId !== null)) && (
        <div className="social-links">
          {facebookId !== undefined &&
            facebookId !== '' &&
            facebookId !== null && (
              <div className="social-icon">
                <a
                  href={checkAndAddHttpProtocal(facebookId)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookIcon className="svg-icon new-TwitterIcon" />
                </a>
              </div>
            )}
          {twitterId !== undefined && twitterId !== '' && twitterId !== null && (
            <div className="social-icon">
              <a
                href={checkAndAddHttpProtocal(twitterId)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <TwitterIcon className="svg-icon new-TwitterIcon" />
              </a>
            </div>
          )}
          {youtubeId !== undefined && youtubeId !== '' && youtubeId !== null && (
            <div className="social-icon">
              <a
                href={checkAndAddHttpProtocal(youtubeId)}
                target="_blank"
                rel="noopener noreferrer"
              >
                <YoutubeIcon className="svg-icon" />
              </a>
            </div>
          )}
          {linkedInId !== undefined &&
            linkedInId !== '' &&
            linkedInId !== null && (
              <div className="social-icon">
                {newLinkedInId &&
                [2, 3].includes(currentTab) &&
                !allUpdatedFlag ? (
                  <button
                    type="button"
                    className=" new-btn new-btn-for-socila-links"
                    aria-label="NEW"
                  >
                    <a
                      href={checkAndAddHttpProtocal(linkedInId)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <LinkedinIcon className="svg-icon new-linkedinIcon" />
                    </a>
                  </button>
                ) : (
                  <a
                    href={checkAndAddHttpProtocal(linkedInId)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedinIcon className="svg-icon new-linkedinIcon" />
                  </a>
                )}
                {hoverEffect && allUpdatedFlag && (
                  <div className="ripple-effect" />
                )}
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default SocialLinks;
export { SocialLinks };
